import Vue from 'vue';
import Vuex from 'vuex';
import * as dd from 'dingtalk-jsapi';
import { logIn } from '../api/home';
import { Toast } from 'vant';

// 持久化store，默认不开启，省流量
// import persistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: null,
  },
  getters: {},
  actions: {
    async dingdingLogin() {
      const cropId = 'dingf080084b208857e84ac5d6980864d335'; // 企业id
      const ding = await dd.runtime.permission.requestAuthCode({
        corpId: cropId,
        onFail: err => {
          Toast.fail(err.errorMessage || '系统错误 请稍后再试');
        },
      });
      const res = await logIn(ding.code).catch(err => {
        if (err.msgContent) Toast.fail(err.msgContent);
      });
      if (res) {
        window.sessionStorage.setItem('dingdingAuth', res);
        window.localStorage.setItem('dingdingAuthToken', res);
      }
      return res;
    },
  },
  mutations: {
    setMenu(state, val) {
      state.menu = val;
    },
  },
});
